/**
 * Currency Pre-Converter for Product Card v2
 * Prevents price flickering by hiding and converting prices before display
 * Place this script in <head> section before other currency scripts
 */

(function() {
    'use strict';
    
    // Ukryj ceny na starcie (zanim DOM się w pełni załaduje)
    const style = document.createElement('style');
    style.id = 'currency-preload-hide';
    style.textContent = `
        .price .money,
        .productView-price .money,
        .sticky-price .money,
        .money-subtotal .money,
        .money-compare-price .money,
        span.money {
            visibility: hidden !important;
            opacity: 0 !important;
        }
    `;
    document.head.appendChild(style);

    // Funkcja odczytu cookie
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    // Funkcja zapisu cookie
    function setCookie(name, value, options) {
        options = options || {};
        let expires = '';
        
        if (options.expires) {
            if (typeof options.expires === 'number') {
                const date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                expires = `; expires=${date.toUTCString()}`;
            } else if (options.expires.toUTCString) {
                expires = `; expires=${options.expires.toUTCString()}`;
            }
        }
        
        const path = options.path ? `; path=${options.path}` : '; path=/';
        const domain = options.domain ? `; domain=${options.domain}` : '';
        const secure = options.secure ? '; secure' : '';
        
        document.cookie = `${name}=${encodeURIComponent(value)}${expires}${path}${domain}${secure}`;
    }

    // Funkcja formatowania kwoty
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || '${{amount}}';
        
        function defaultOption(opt, def) {
            return typeof opt === 'undefined' ? def : opt;
        }
        
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');
            
            if (isNaN(number) || number == null) return 0;
            
            number = (number / 100.0).toFixed(precision);
            
            const parts = number.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            const cents = parts[1] ? (decimal + parts[1]) : '';
            
            return dollars + cents;
        }
        
        const match = formatString.match(placeholderRegex);
        if (!match) return formatString;
        
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
        
        return formatString.replace(placeholderRegex, value);
    }

    // Funkcja konwersji waluty z niestandardowym zaokrąglaniem
    function convertCurrency(cents, fromCurrency, toCurrency, rates, formats) {
        if (fromCurrency === toCurrency) return cents;
        
        const from = rates[fromCurrency];
        const to = rates[toCurrency];
        
        if (!from || !to) {
            console.warn(`Missing exchange rate: ${fromCurrency} (${from}) -> ${toCurrency} (${to})`);
            return cents;
        }
        
        // WAŻNE: Currency.rates to kursy względem USD w formacie:
        // rates[currency] = ile USD jest warte 1 jednostkę tej waluty
        // Przykład: EUR = 1.16178 oznacza że 1 EUR = 1.16178 USD
        //           SEK = 0.105157 oznacza że 1 SEK = 0.105157 USD
        
        // Aby przeliczyć z EUR na SEK:
        // 1. Przelicz EUR na USD: centy_EUR / 100 * kurs_EUR_do_USD
        // 2. Przelicz USD na SEK: USD / kurs_SEK_do_USD
        // Czyli: (centy_EUR / 100 * from) / to * 100
        
        const amountInFromCurrency = cents / 100; // Zamień centy na pełne jednostki
        const amountInUSD = amountInFromCurrency * from; // Przelicz na USD
        const amountInToCurrency = amountInUSD / to; // Przelicz z USD na walutę docelową
        let convertedAmount = amountInToCurrency * 100; // Zamień z powrotem na centy
        
        console.log(`Converting ${cents} cents (${amountInFromCurrency} ${fromCurrency}):`);
        console.log(`  → ${amountInUSD.toFixed(2)} USD (rate: ${from})`);
        console.log(`  → ${amountInToCurrency.toFixed(2)} ${toCurrency} (rate: ${to})`);
        console.log(`  → ${convertedAmount.toFixed(0)} cents in ${toCurrency}`);
        
        // Niestandardowe zaokrąglanie
        const amountInUnits = convertedAmount / 100;
        let finalAmount;
        
        if (['INR', 'DKK', 'RON', 'HUF'].includes(toCurrency)) {
            // Zaokrąglenie do pełnych jednostek
            finalAmount = Math.floor(amountInUnits);
            convertedAmount = finalAmount * 100;
            console.log(`  → ${toCurrency} rounds to whole units: ${finalAmount}`);
        } else if (toCurrency === 'EUR') {
            // EUR zachowuje pełną precyzję
            finalAmount = amountInUnits;
            convertedAmount = Math.round(finalAmount * 100);
            console.log(`  → EUR keeps precision: ${finalAmount.toFixed(2)}`);
        } else {
            // Zaokrąglenie do 1 miejsca po przecinku
            finalAmount = Math.floor(amountInUnits * 10) / 10;
            convertedAmount = Math.round(finalAmount * 100);
            console.log(`  → ${toCurrency} rounds to 1 decimal: ${finalAmount.toFixed(1)}`);
        }
        
        return Math.round(convertedAmount);
    }

    // Funkcja wyciągania wartości w centach z różnych formatów
    function extractCentsValue(element, shopCurrency) {
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.log('🔍 EXTRACTING CENTS VALUE');
        console.log('Element HTML:', element.outerHTML.substring(0, 200));
        
        // METODA 1: Sprawdź czy element ma już zapisaną wartość w data-currency-SHOP
        const shopCurrencyAttr = `data-currency-${shopCurrency}`;
        const cachedShopValue = element.getAttribute(shopCurrencyAttr);
        
        console.log(`Checking ${shopCurrencyAttr}:`, cachedShopValue);
        
        if (cachedShopValue) {
            // Usuń wszystkie znaki oprócz cyfr
            const numericValue = parseInt(cachedShopValue.replace(/[^0-9]/g, ''), 10);
            if (!isNaN(numericValue) && numericValue > 0) {
                console.log('✅ Using cached shop value:', cachedShopValue, '→', numericValue, 'cents');
                console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
                return numericValue;
            }
        }
        
        // METODA 2: Czytaj z HTML ale inteligentnie
        const originalHTML = element.innerHTML.trim();
        
        // Usuń wszystkie znaki HTML i pozostaw tylko tekst
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = originalHTML;
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        
        console.log('Original text:', textContent);
        
        // Sprawdź czy jest separator dziesiętny
        const hasComma = textContent.includes(',');
        const hasDot = textContent.includes('.');
        
        // Wyciągnij wszystkie cyfry
        const digitsOnly = textContent.replace(/[^0-9]/g, '');
        const numericValue = parseInt(digitsOnly, 10);
        
        if (isNaN(numericValue) || numericValue === 0) {
            console.warn('Could not extract numeric value from:', textContent);
            return 0;
        }
        
        console.log('Digits only:', digitsOnly, '→', numericValue);
        
        // LOGIKA DECYZYJNA:
        // 1. Jeśli tekst ma separator (. lub ,) to wartość jest już w centach po usunięciu separatora
        //    np. "€6.99" → "699" → 699 centów ✓
        //    np. "6,99 €" → "699" → 699 centów ✓
        if (hasComma || hasDot) {
            console.log('Has decimal separator, value is in cents:', numericValue);
            return numericValue;
        }
        
        // 2. Jeśli nie ma separatora ale liczba ma więcej niż 2 cyfry, zakładamy że to centy
        //    np. "699" → 699 centów ✓
        //    np. "1059" → 1059 centów (10.59) ✓
        if (digitsOnly.length > 2) {
            console.log('No separator but long number, treating as cents:', numericValue);
            return numericValue;
        }
        
        // 3. Jeśli liczba ma 1-2 cyfry bez separatora, to prawdopodobnie pełne jednostki
        //    np. "7" → 700 centów
        //    np. "99" → może być 99 centów lub 99 jednostek (edge case)
        // W tym przypadku lepiej założyć że to centy (bezpieczniejsze)
        console.log('Short number without separator, treating as cents:', numericValue);
        return numericValue;
    }

    // Główna funkcja konwersji
    function preConvertPrices() {
        // Sprawdź czy Currency jest dostępne
        if (typeof Currency === 'undefined' || !Currency.moneyFormats) {
            console.log('Currency object not ready, retrying...');
            setTimeout(preConvertPrices, 50);
            return;
        }

        const shopCurrency = window.Shopify?.currency?.active || 'EUR';
        const cookieCurrency = getCookie('currency');
        const targetCurrency = cookieCurrency || shopCurrency;
        
        console.log('Shop currency:', shopCurrency);
        console.log('Target currency:', targetCurrency);
        
        // Jeśli waluta jest taka sama, po prostu pokaż ceny
        if (targetCurrency === shopCurrency) {
            console.log('Same currency, showing prices immediately');
            showPrices();
            return;
        }

        const rates = Currency.rates || {};
        const formats = Currency.moneyFormats || {};
        
        console.log('Exchange rates:', rates);
        console.log('EUR rate:', rates[shopCurrency]);
        console.log('SEK rate:', rates[targetCurrency]);
        
        // Znajdź wszystkie elementy z cenami
        const priceElements = document.querySelectorAll('span.money');
        
        console.log('Found', priceElements.length, 'price elements');
        
        let convertedCount = 0;
        
        priceElements.forEach((element, index) => {
            // Sprawdź czy już ma docelową walutę
            const currentCurrency = element.getAttribute('data-currency');
            if (currentCurrency === targetCurrency) {
                console.log(`Element ${index}: Already in target currency`);
                return;
            }
            
            // Sprawdź cache
            const cachedValue = element.getAttribute(`data-currency-${targetCurrency}`);
            if (cachedValue) {
                console.log(`Element ${index}: Using cached value for ${targetCurrency}:`, cachedValue);
                element.innerHTML = cachedValue;
                element.setAttribute('data-currency', targetCurrency);
                convertedCount++;
                return;
            }
            
            // Wyciągnij wartość w centach
            const centsValue = extractCentsValue(element, shopCurrency);
            
            if (centsValue === 0) {
                console.warn(`Element ${index}: Could not extract valid cents value`);
                return;
            }
            
            console.log(`Element ${index}: Cents value: ${centsValue}`);
            
            // Konwertuj walutę
            const convertedCents = convertCurrency(
                centsValue,
                shopCurrency,
                targetCurrency,
                rates,
                formats
            );
            
            console.log(`Element ${index}: Converted to ${convertedCents} cents in ${targetCurrency}`);
            
            // Formatuj nową wartość
            const toFormat = formats[targetCurrency]?.money_format || '{{amount}}';
            const formattedMoney = formatMoney(convertedCents, toFormat);
            
            console.log(`Element ${index}: Formatted: ${formattedMoney}`);
            
            // Aktualizuj element
            element.innerHTML = formattedMoney;
            element.setAttribute('data-currency', targetCurrency);
            element.setAttribute(`data-currency-${targetCurrency}`, formattedMoney);
            
            convertedCount++;
        });
        
        console.log(`Converted ${convertedCount} price elements`);
        
        // Aktualizuj symbole waluty
        const currencySymbols = document.querySelectorAll('.format-currency');
        if (currencySymbols.length > 0) {
            const toFormat = formats[targetCurrency]?.money_format || '{{amount}}';
            const symbol = toFormat.replace(/{{amount}}|{{amount_no_decimals}}|{{amount_with_comma_separator}}|{{amount_no_decimals_with_comma_separator}}|\s/g, '');
            currencySymbols.forEach(el => {
                el.textContent = symbol;
            });
        }
        
        // Ustaw globalną walutę
        if (typeof Currency !== 'undefined') {
            Currency.currentCurrency = targetCurrency;
            setCookie('currency', targetCurrency, {
                expires: 365,
                path: '/',
                domain: window.location.hostname
            });
        }
        
        // Pokaż ceny
        showPrices();
    }

    // Funkcja pokazująca ceny
    function showPrices() {
        console.log('Showing prices...');
        const hideStyle = document.getElementById('currency-preload-hide');
        if (hideStyle) {
            hideStyle.remove();
        }
        
        const showStyle = document.createElement('style');
        showStyle.textContent = `
            .price .money,
            .productView-price .money,
            .sticky-price .money,
            .money-subtotal .money,
            .money-compare-price .money,
            span.money {
                visibility: visible !important;
                opacity: 1 !important;
                transition: opacity 0.3s ease-in;
            }
        `;
        document.head.appendChild(showStyle);
    }

    // Wykonaj konwersję gdy DOM jest gotowy
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', preConvertPrices);
    } else {
        preConvertPrices();
    }

    // Fallback timeout
    setTimeout(function() {
        const hideStyle = document.getElementById('currency-preload-hide');
        if (hideStyle) {
            console.warn('Currency conversion timeout - showing prices anyway');
            showPrices();
        }
    }, 2000);

})();